module.exports = __webpack_public_path__ + "static/MENU_1-f29bdee9d014d7cd307d2fd856166ac4.png";